import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { toast } from 'sonner';
import api from '../../utils/api';
import { useTenant } from '../../context/TenantContext';

const CatalogVendors = () => {
  const { activeTenant } = useTenant();
  const [vendors, setVendors] = useState([]);
  const [formData, setFormData] = useState({ name: '', nif: '', email: '', address: '' });

  const loadVendors = () => {
    if (!activeTenant) return;
    api.get(`/catalog/vendors?tenant_id=${activeTenant}`)
      .then((res) => setVendors(res.data || []))
      .catch(() => toast.error('Error al cargar proveedores'));
  };

  useEffect(() => {
    loadVendors();
  }, [activeTenant]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.name) {
      toast.error('Nombre requerido');
      return;
    }
    try {
      await api.post('/catalog/vendors', { ...formData, tenant_id: activeTenant });
      toast.success('Proveedor registrado');
      setFormData({ name: '', nif: '', email: '', address: '' });
      loadVendors();
    } catch (error) {
      toast.error('Error al guardar proveedor');
    }
  };

  const handleDelete = async (vendorId) => {
    try {
      await api.delete(`/catalog/vendors/${vendorId}`);
      toast.success('Proveedor eliminado');
      loadVendors();
    } catch (error) {
      toast.error('Error al eliminar proveedor');
    }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-6" data-testid="catalog-vendors">
      <div>
        <h1 className="text-3xl font-heading font-bold">Proveedores para gastos</h1>
        <p className="text-muted-foreground">Registra proveedores del tenant seleccionado.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Nuevo proveedor</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label>Nombre *</Label>
              <Input value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
            </div>
            <div>
              <Label>NIF</Label>
              <Input value={formData.nif} onChange={(e) => setFormData({ ...formData, nif: e.target.value })} />
            </div>
            <div>
              <Label>Email</Label>
              <Input value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
            </div>
            <div className="md:col-span-2">
              <Label>Direccion</Label>
              <Textarea value={formData.address} onChange={(e) => setFormData({ ...formData, address: e.target.value })} />
            </div>
            <div className="md:col-span-2">
              <Button type="submit">Guardar proveedor</Button>
            </div>
          </form>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Proveedores registrados</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {vendors.length === 0 ? (
            <div className="px-6 py-6 text-sm text-muted-foreground">No hay proveedores registrados.</div>
          ) : (
            vendors.map((vendor) => (
              <div key={vendor.id} className="flex items-center justify-between px-6 py-4 border-b last:border-b-0">
                <div>
                  <div className="font-medium">{vendor.name}</div>
                  <div className="text-xs text-muted-foreground">{vendor.nif || 'Sin NIF'}</div>
                </div>
                <Button variant="ghost" size="sm" onClick={() => handleDelete(vendor.id)}>
                  Eliminar
                </Button>
              </div>
            ))
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default CatalogVendors;
